import { CLIENT_ID, CLIENT_SECRET, PLAYER_UID } from '@env';

export function getAuthToken(callback: any) {
    var authForm = new FormData();
    var auth = 'Basic ' + btoa(CLIENT_ID + ':' + CLIENT_SECRET);

    performRequest("https://api.avatarsdk.com/o/token/", "POST", authForm, "json", (resp: any) => {
        var token_str = 'Bearer ' + resp.access_token;
        
        //getPlayerUID(token_str);
        callback(token_str);
      }, (resp: any) =>
      {
        var err = JSON.stringify(resp);
        console.log(err);
        callback(null);
      }, auth);
}

export function createAvatar(name: string, image: any, token:string, callback: any) {
    var parameters = {
        "model_info": {
          "plus": [
            "gender",
            "age",
            "race"
          ]
        },
        "additional_textures": {
          "plus": ["lips_mask"]
        },
        "blendshapes": {
          "base": ["mobile_51", "visemes_15"]
        },
        "avatar_modifications": {
          "plus" : {
            "repack_texture" : true,
            "texture_size" : {"width":1024,"height":1024}
          }
        }
      }

    var form = new FormData();
    form.append("name", name);
    form.append("pipeline", "head_1.2");
    form.append("pipeline_subtype", "base/mobile");
    form.append("parameters", JSON.stringify(parameters));
    //console.log(JSON.stringify(parameters));
    var blob = dataURLtoBlob(image);
    form.append("photo", blob, "photo.jpeg");
    performRequest("https://api.avatarsdk.com/avatars/", "POST", form, "json", (resp: any) => {
        console.log(JSON.stringify(resp));
        callback(resp);
      }, (resp: any) =>
      {
        var err = JSON.stringify(resp);
        console.log(err);
        callback(null);
      }, token);
}

export function getRequest(url: string, token: string, callback: any)  {
    performRequest(url, "GET", null, "json", (resp: any) => {
        callback(resp);
      }, (resp: any) =>
      {
        var err = JSON.stringify(resp);
        console.log(err);
        callback(null);
      }, token);
}

function performRequest(url: string, method: string, data: any, expectedResponse: any, onSuccess: any, onFailure: any, auth: string) {
    var xhr = new XMLHttpRequest();
    if (data) {
        data.append('grant_type', 'client_credentials');
    }

    xhr.addEventListener('load', (ev: any) => {
      var status = ev.target.status;
      if (status >= 200 && status < 300) {
        if (!!onSuccess) {
            onSuccess(ev.target.response, ev);
        }
      } else {
        if (!!onFailure) {
            onFailure(ev.target.response, ev);
        }
      }
    });

    xhr.open(method, url);
    xhr.responseType = expectedResponse;
    xhr.setRequestHeader('Authorization', auth);

    if (!!PLAYER_UID) {
      xhr.setRequestHeader('X-PlayerUID', PLAYER_UID);
    }
    xhr.send(data);
}

// For future use
// function getPlayerUID(token: string) {
//   if (player_uid === undefined) {
//     var xhr = new XMLHttpRequest();
//     xhr.addEventListener('load', (ev: any) => {
//       var status = ev.target.status;
//       if (status >= 200 && status < 300) {
//         const code = ev.target.response.code;
//         console.log(code);
//         player_uid = code;
//       }
//       else {
//         console.log(ev.target.response);
//       }
//     });

//     xhr.open("POST", "https://api.avatarsdk.com/players/");
//     xhr.responseType = "json";
//     xhr.setRequestHeader('Authorization', token);
//     xhr.send();
//   }
// }

function dataURLtoBlob(dataurl: string) {
  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
}